import React, { Component, Suspense, lazy } from "react";
import { Switch, Route } from "react-router-dom";
import { ConnectedRouter } from "react-router-redux";
import configureStore from "./redux/store/configureStore";
import { history } from "./redux/store/configureStore";
// import App from "./containers/app";
const App = lazy(() => import("./containers/app"));
import ScrollTop from "./components/scrollToTop/ScrollToTop";
import PageNotFound from "./views/pageNotFound";
import Authorization from "./routes/Authorization";
import publicRoutes from "./routes/publicRoutes";
import affiliateRoutes from "./routes/affiliateRoutes";
// import PublicLayout from "./layout/PublicLayout";
const PublicLayout = lazy(() => import("./layout/PublicLayout"));
// import AffiliateLayout from "./layout/AffiliateLayout";
const AffiliateLayout = lazy(() => import("./layout/AffiliateLayout"));
import Maintenance from "./views/frontend/maintenance";
import { siteActions } from "./redux/actions/siteActions";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { withRouter } from "react-router";
import isEmpty from "lodash.isempty";
import "./InitialSetup.css";
import packageJson from "./package.json";
import {Helmet} from "react-helmet";
import Cookies from "universal-cookie";
const cookies = new Cookies();

let sitestatus = "",
  siteprotocol = "";
class InitialSetup extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      siteStatus: "",
    };
  }

  componentWillMount() {
    if (
      isEmpty(this.props.siteStatus) ||
      typeof this.props.siteStatus != "undefined"
    ) {
      let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
      let siteUrl = history.location.pathname.split("/");
      let url = window.location.href;
      const {
        actions: { checkSiteStatus },
      } = this.props;
      if (url.includes("centraloregondeals.com") === true && siteUrl[1] == "") {
        checkSiteStatus("17325cfabfecb700ff670d3b9fae5177");
      } else if (
        url.includes("discoverourcoastdeals.com") === true &&
        siteUrl[1] == ""
      ) {
        checkSiteStatus("85143b9b877f733c6c0c9344cf54c12d");
      } else if (
        url.includes("easternoregondeals.com") === true &&
        siteUrl[1] == ""
      ) {
        checkSiteStatus("a49f4c027976739e224a19da9b5368f0");
      } else if (
        !isEmpty(siteUrl) &&
        siteUrl[1] &&
        siteUrl[2] &&
        siteUrl[1] == "city-deal"
      ) {
        checkSiteStatus(siteUrl[2]);
      } else {
        if (siteData && siteData.default_city) {
          checkSiteStatus(siteData.default_city);
          
        } else {
          checkSiteStatus();
        }
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.siteStatus && this.state.siteStatus != nextProps.siteStatus) {
      this.setState({ siteStatus: nextProps.siteStatus });
      if (
        typeof cookies.get("cityID") != "undefined" ||
        typeof cookies.get("default_lang") != "undefined"
      ) {
        let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
        if (typeof cookies.get("cityID") != "undefined") {
          siteData.default_city = cookies.get("cityID");
        }
        if (typeof cookies.get("default_lang") != "undefined") {
          siteData.default_lang = cookies.get("default_lang");
        }
        localStorage.setItem(
          "siteDDBStatus",
          JSON.stringify(nextProps.siteStatus)
        );
        let version = localStorage.getItem("version");

        // if (
        //   nextProps.siteStatus.appversion != version ||
        //   version === null ||
        //   typeof version == "undefined"
        // ) {
        //   if ("caches" in window) {
        //     caches.keys().then((names) => {
        //       // Delete all the cache files
        //       names.forEach((name) => {
        //         caches.delete(name);
        //       });
        //     });

        //     // Makes sure the page reloads. Changes are only visible after you refresh.
        //     window.location.reload(true);
        //   }

        //   localStorage.clear();
        //   localStorage.setItem("version", nextProps.siteStatus.appversion);
        //   window.location.reload(true);
        // }
        siteprotocol = nextProps.siteStatus.siteDomain.split(":");
        sitestatus = nextProps.siteStatus.status;
      } else {
        siteprotocol = nextProps.siteStatus.siteDomain.split(":");
        sitestatus = nextProps.siteStatus.status;
      }
    }

    if (
      (history.location.pathname == "/" || history.location.pathname == "") &&
      nextProps.siteStatus.customurl &&
      nextProps.siteStatus.customurl != ""
    ) {
      history.replace("/page/" + nextProps.siteStatus.customurl);
    }
  }

  render() {
    const user = {};

    if (sitestatus == "Inactive") {
      return <Maintenance />;
    } else if (sitestatus == "Active") {
      return (

        <div className="main-container" style={{ height: "100%" }}>
         <Helmet>
  <meta property="og:title" content="Payvibe"/>
      
            </Helmet>
          <ConnectedRouter basename={process.env.PUBLIC_URL} history={history}>
            <ScrollTop>
              <Suspense
                fallback={
                  <div className="loader">
                    <p className="loading-message">
                      <i>Loading...</i>
                    </p>
                    <div className="spinner">
                      <div className="dot1" />
                      <div className="dot2" />
                    </div>
                  </div>
                }
              >
                <Switch>
                  {_.map(publicRoutes, (route, key) => {
                    const { component, path } = route;
                    return (
                      <Route
                        exact
                        path={path}
                        key={key}
                        render={(route) => (
                          <PublicLayout
                            component={component}
                            route={route}
                            user={user}
                          />
                        )}
                      />
                    );
                  })}
                  {_.map(affiliateRoutes, (route, key) => {
                    const { component, path } = route;
                    return (
                      <Route
                        exact
                        path={path}
                        key={key}
                        render={(route) => (
                          <AffiliateLayout
                            component={component}
                            route={route}
                            user={user}
                          />
                        )}
                      />
                    );
                  })}
                  <App />
                  <Route component={PageNotFound} />
                </Switch>
              </Suspense>
            </ScrollTop>
          </ConnectedRouter>
        </div>
      );
    } else {
      return (
        <div className="loader">
          <p className="loading-message">
            <i>Loading...</i>
          </p>
          <div className="spinner">
            <div className="dot1" />
            <div className="dot2" />
          </div>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    error: state.designCenterReducer.error,
    siteStatus: state.siteReducer.siteStatus,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(
      {
        ...siteActions,
      },
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InitialSetup);



// WEBPACK FOOTER //
// ./src/app/InitialSetup.js